import {profSpac} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadProfSpac() {
  return useLoad(profSpac, 'iD_ProfileSpac', {});
}

export default useLoadProfSpac;
